export const status = {
  active: 'Aktív',
  inactive: 'Inaktív'
}
